import Button from "@/components/editor/primitives/button/button-component";
import Iframe from "@/components/editor/primitives/iframe/iframe-component";
import ImageNew from "@/components/editor/primitives/image/image-component";
import Action from "@/components/editor/primitives/legacy/action/action-component";
import Image from "@/components/editor/primitives/legacy/image/image-component";
import PageContainer from "@/components/editor/primitives/page-container/page-container-component";
import RichTextEditor from "@/components/editor/primitives/rich-text";
import Text from "@/components/editor/primitives/text/text-component";
import Video from "@/components/editor/primitives/video/video-component";
import TopLevelIFrame from "@/components/editor/shared/media/iframe/iframe-component";
import EmbeddedSchedule from "@/components/editor/shared/schedules/embedded-schedule/embedded-schedule-component";

const baseResolvedBlocks = {
  PageContainer,
  Text,
  Action,
  Image,
  RichTextEditor,
  Video,
  Button,
  ImageNew,
  Iframe,
  EmbeddedSchedule,
  TopLevelIFrame,
};

export default baseResolvedBlocks;
